module.exports = __webpack_public_path__ + "static/media/17390584_10154599273233990_6416430327900070522_o.14f464f8.jpg";